import { RouteObject } from "react-router-dom";
import { AgentDossierDetail } from "../pages/admin/agents/AgentDossierDetail";
import AgentsList from "../pages/admin/agents";
import AgentsCreate from "../pages/admin/agents/create";
import AgentsEdit from "../pages/admin/agents/edit";

export const agentsRoutes: RouteObject[] = [
  {
    id: "agents-list",
    index: true,
    element: <AgentsList />,
  },
  {
    id: "agents-create",
    path: "create",
    element: <AgentsCreate />,
  },
  {
    id: "agents-edit",
    path: ":id/edit",
    element: <AgentsEdit />,
  },
  {
    id: "agents-dossier-detail",
    path: "dossiers/:id",
    element: <AgentDossierDetail />,
  },
];
